import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type Props = ApiMethodBase & {
    sf?: string;
}

const sleep = ms => new Promise(r => setTimeout(r, ms));

export async function setFilterConstraint ({
    sf,
    eventEmitter,
}: Props) {
    eventEmitter.emit(Event.setActionBar_Visualizer)
    await sleep(20)
    if (sf === 'filter') {eventEmitter.emit(Event.setFilterExpanded);}
    if (sf === 'discovery') {eventEmitter.emit(Event.setDiscoveryExpanded);}
};

